import * as nav from "./modules/navigation.js";
import * as swiper from "./modules/swiper.js";
import slideToggle from "./modules/slideToggle.js";
import animateOnScroll from "./modules/observer.js";

import jquery from "jquery";
export default window.$ = window.jQuery = jquery;

import { openModal, closeModal } from "./modules/modal.js";

window.addEventListener(
  "load",
  () => {
    document.body.classList.remove("preload");
  },
  false,
);

// Sprig accordion
$(document).on("click", ".sprig-toggle", function () {
  $(this).next().slideToggle();
  $(this).find("svg").toggleClass("hidden");
});

// Sprig filters
let $currentSprigTarget = null;

$(document).on("click", ".sprig-filter-toggle", function (e) {
  e.stopPropagation();

  const $thisToggle = $(this);
  const $thisTarget = $thisToggle.next(".sprig-target");

  // Close previously opened target if it's different
  if ($currentSprigTarget && !$thisTarget.is($currentSprigTarget)) {
    $currentSprigTarget.slideUp();
    $currentSprigTarget
      .prev(".sprig-filter-toggle")
      .find("svg")
      .removeClass("rotate-180");
  }

  $thisTarget.slideToggle();
  $thisToggle.find("svg").toggleClass("rotate-180");
  $currentSprigTarget = $thisTarget.is(":visible") ? $thisTarget : null;
});

$(document).on("click", function (e) {
  const $target = $(e.target);

  if (
    $currentSprigTarget &&
    !$target.closest(".sprig-filter-toggle").length &&
    !$target.closest(".sprig-target").length
  ) {
    $currentSprigTarget.slideUp();
    $currentSprigTarget
      .prev(".sprig-filter-toggle")
      .find("svg")
      .removeClass("rotate-180");
    $currentSprigTarget = null;
  }
});

// Sprig load more
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

function handleScroll() {
  const button = document.querySelector("#load-more-oob");
  if (button && isInViewport(button)) {
    button.click();
  }
}

window.addEventListener("scroll", handleScroll);
window.addEventListener("load", handleScroll);

// Newsletter toggle
$(document).on("click", ".open-maillist", function () {
  const form = $(".maillist");
  const inner = form.find(".inner");

  openModal();
  form.removeClass("hidden");
  inner.addClass("header-animate");
});

$(document).on("click", ".close-maillist", function () {
  const form = $(".maillist");
  const inner = form.find(".inner");

  closeModal();
  form.addClass("hidden");
  inner.removeClass("header-animate");
});

$(document).on("click", ".maillist .overlay", function () {
  const form = $(".maillist");

  closeModal();
  form.addClass("pointer-events-none").removeClass("translate-y-0");
});

// Bio toggle
$(document).on("click", ".open-bio", function () {
  const bio = $(this).parent().next(".bio");
  const overlay = bio.find(".overlay");
  const container = bio.find(".slide");

  openModal();
  bio.removeClass("pointer-events-none");
  overlay.addClass("opacity-100");
  container.addClass("translate-x-0");
});

$(document).on("click", ".close-bio", function () {
  const bio = $(this).parent().parent();
  const overlay = bio.find(".overlay");
  const container = bio.find(".slide");

  closeModal();
  bio.addClass("pointer-events-none");
  overlay.removeClass("opacity-100");
  container.removeClass("translate-x-0");
});

$(document).on("click", ".bio .overlay", function () {
  const bio = $(this).parent();
  const overlay = bio.find(".overlay");
  const container = bio.find(".slide");

  closeModal();
  bio.addClass("pointer-events-none");
  overlay.removeClass("opacity-100");
  container.removeClass("translate-x-0");
});
